module.exports = __webpack_public_path__ + "media/typy/osobowe-fcc7bd30.png";